import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { PROCESS } from "../../lib/data";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#0f0f0f] py-24 sm:py-36 border-y border-white/10"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <Reveal>
          <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-[#e62429] mb-6">
            <span className="h-px w-10 bg-[#e62429]" /> What we do with it
          </p>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl leading-[0.9] max-w-3xl">
            One process, end to end.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-0 border-t border-l border-white/12">
          {PROCESS.map((step, i) => (
            <motion.div
              key={step.title}
              data-testid={`process-step-${step.title.toLowerCase()}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group relative border-r border-b border-white/12 p-8 sm:p-10 min-h-[240px] flex flex-col justify-between overflow-hidden"
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{ backgroundColor: step.color }}
              />
              <div className="relative z-10 flex items-center justify-between">
                <span className="font-display text-xl text-neutral-500 group-hover:text-white/80 transition-colors">
                  0{i + 1}
                </span>
                {i < PROCESS.length - 1 && (
                  <ArrowRight className="h-6 w-6 text-neutral-600 group-hover:text-white transition-colors" />
                )}
              </div>
              <div className="relative z-10">
                <h3
                  className="font-display uppercase text-4xl sm:text-5xl transition-colors duration-300"
                  style={{ color: step.color }}
                >
                  <span className="group-hover:text-white transition-colors duration-300">
                    {step.title}
                  </span>
                </h3>
                <p className="mt-2 text-sm uppercase tracking-[0.15em] font-bold text-neutral-400 group-hover:text-white/90 transition-colors">
                  {step.sub}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
